import components_hash_proxy from './components'
import {
    VForm,
    VRow,
    VCol,
  } from 'vuetify/lib'

export default {
    name: 'v-form',
    props: {
        fields: {
            type:Array,
            required: true,
            default: () => []
        },
        value: {
            type: Object,
        },
        rowProps: {
            type: Object,
        },
        
        formProps: {
            type: Object,
        },
        cols: {
            type: [ Number, String ],
        },
        md: {
            type: [ Number, String ],
        }
    },
    data() {
        return {
            my_value: this.value || {},
        }
    },
    watch: {
        value(new_val) {
            this.my_value = new_val
        },
        my_value(new_val) {
            this.$emit('input', new_val)
        }
    },
    methods: {
        getData() {
            return this.my_value
        },
        valid_key() {
            const hash = {}
            this.fields.forEach(({key}) => {
                if (['', undefined, null].includes(key)) {
                    throw new Error(`fields的key值必须存在`);  
                }   
                if (hash[key]) {
                    throw new Error(`fields的key值必须单独唯一`);
                }
                hash[key] = true
            })
        },
        reset() {
            return this.$refs.form.reset()
        },
        resetValidation() {
            return this.$refs.form.resetValidation()
        },
        validate() {
            return this.$refs.form.validate()
        },
        get() {
            return this.my_value
        }
    },
    mounted() {
    
    },
    render(h) {
        // row的props
        const rowProps = this.rowProps || {}
        // form表单的props
        const formProps = this.formProps || {}
        // 列表
        const components_arr = this.fields.map(field => {
            const { type, cols, md, col_props = {}, ..._field } = field
            col_props.cols = cols || col_props.cols || this.cols || 12
            col_props.md = md || col_props.md || this.md || col_props.cols || 12
            const slot = this.$scopedSlots[field.key]
            let child_component = null
            if (slot) {
                const _field = {...field}
                if (field.required) {
                    _field.scopedSlots = _field.scopedSlots || {}
                    !_field.scopedSlots.label && (_field.scopedSlots.label = () => {
                        return h('span', {}, [
                            h('span', {
                                style: {
                                    color: 'red'
                                }
                            }, '*'),
                            h('span', {}, _field.label),
                        ])
                    })
                }
                child_component = slot({
                    field:_field,
                    value: this.my_value
                })
            } else {
                const component = components_hash_proxy[type]
                const scopedSlots = _field.scopedSlots = _field.scopedSlots || {}
                if (_field.required && !_field.scopedSlots.label) {
                    scopedSlots.label = () => {
                        return h('span', {}, [
                            h('span', {
                                style: {
                                    color: 'red'
                                }
                            }, '*'),
                            h('span', {}, _field.label),
                        ])
                    }
                }
                child_component = component ? h(component, {
                    props: {
                        field: _field,
                        value: this.my_value
                    }
                }) : null
            }

            return h(VCol, {
                key: _field.key,
                props: col_props
            }, [child_component])
        })
        return h(VForm, {
            ref: 'form',
            style: {
                width:'100%'
            },
            props: {
                value: true,
                ...formProps
            },
        }, 
         [
            h(VRow, {
                props: rowProps
            }, [ components_arr ])
        ]
        )
    }
}